import { Capacitor, registerPlugin } from "@capacitor/core";

interface AndroidActionsPlugin {
  openSettings(): Promise<void>;
  savePdf(options: { uri: string }): Promise<{ saved: boolean }>;
  saveBackup(options: { uri: string }): Promise<{ saved: boolean }>;
}

export const AndroidActions = registerPlugin<AndroidActionsPlugin>("AndroidActions");
export const isAndroidApp = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";
